export default "__VITE_ASSET__DAjB6kNO__"